import { defineComponent } from 'vue';
import { SHOW_BRAND } from '@/utils';
export default defineComponent({
  name: 'HomeFooter',
  data: function () {
    return {
      SHOW_BRAND: SHOW_BRAND
    };
  }
});